<template>
    <form @submit.prevent="submit()">
        <div class="row">
            <div class="col-md-6 mb-3">
                <text-input
                    v-model="form.student_name" class="form-control"
                    :error="form.errors.student_name"
                    label="Nome" type="text" placeholder="Nome" required/>
            </div>
            <div class="col-md-6 mb-3">
                <text-input
                    v-model="form.student_last_name" class="form-control"
                    :error="form.errors.student_last_name"
                    label="Sobrenome" placeholder="Sobrenome" required/>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <text-input
                        v-model="form.student_phone" v-mask="'(##)# ####-####'" class="form-control"
                        :error="form.errors.student_phone"
                        label="Telefone" type="text" placeholder="Telefone"
                        required/>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <text-input
                        v-model="form.student_mail" class="form-control"
                        :error="form.errors.student_mail"
                        label="E-mail" type="email" placeholder="E-mail" required/>
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-6 mb-3">
                <text-input
                    v-model="form.student_birth_date" v-mask="'##/##/####'"
                    :error="form.errors.student_birth_date"
                    id="student_birth_date" :group="true" type="text"
                    label="Data de nascimento"
                    placeholder="Data de nascimento"
                    required>
                    <span class="input-group-text">
                        <svg class="icon icon-xs" fill="currentColor" viewBox="0 0 20 20"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                  d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </span>
                </text-input>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-6 mb-3">
                <label for="student_city">Cidade</label>
                <select
                    v-model="form.student_city"
                    v-on:change="changeCity"
                    class="form-select mb-0" id="student_city">
                    <option value="" disabled selected hidden>Selecione uma cidade</option>
                    <option v-for="city in this.cities" :value="city.id">{{ city.name }}</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label for="student_organization">Unidade gestora</label>
                <select
                    v-model="form.organization_id" class="form-select mb-0"
                    id="student_organization">
                    <option value="" disabled selected hidden>Selecione uma unidade gestora</option>
                    <option v-for="(organization, index) in organizations" :value="organization.id">
                        {{ organization['organization_name'] }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-3">
                <label for="student_class">Edição</label>
                <select
                    v-model="form.student_class"
                    class="form-select mb-0" id="student_class">
                    <option value="" disabled selected hidden>Selecione uma data</option>
                    <option v-for="edition in editions" :value="edition.id">
                        Início {{ this.$moment(edition['class_start_date']).format('DD/MM/YYYY') }} e Termino em {{ this.$moment(edition['class_end_date']).format('DD/MM/YYYY') }}
                    </option>
                </select>
            </div>
        </div>
        <div class="d-flex justify-content-end w-100 flex-wrap">
            <button class="btn btn-gray-800 mt-2 animate-up-2" type="submit">Enviar inscrição</button>
        </div>
    </form>
</template>

<script>
import TextInput from "@/Utils/TextInput"
import {useForm} from '@inertiajs/vue3'
import {mapState} from 'vuex';

export default {
    name: "Inscription",
    components: {
        TextInput
    },
    data() {
        return {
            form: useForm({
                token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                course_code: '_',
                student_name: '',
                student_last_name: '',
                student_phone: '',
                student_mail: '',
                student_birth_date: '',
                student_city: '',
                organization_id: '',
                student_class: '',
            }),
            organizations: [],
        };
    },
    computed: {
        ...mapState('inscription', ['course_code', 'cities', 'editions'])
    },
    mounted() {
        this.form.course_code = this.course_code
    },
    methods: {
        async submit() {
            await this.form.post('/inscriptions/save');
        },
        async changeCity() {
            const self = this;
            await axios.get('/api/organizations/municipality/' + this.form.student_city)
                .then(function ({data}) {
                    self.organizations = data
                });
        }
    }
}
</script>

<style scoped>

</style>

